// Préchargement d'un même lieu : le Dispatch donne une ligne par commande, le consolidateur voit un seul passage.
const grouped = visit => visit.kind === "loading" && visit.planned_inherited && !visit.pm;

export const loadingGroup = (visits, visit) => (grouped(visit)
  ? visits.filter(other => grouped(other) && other.label === visit.label) : [visit]);

// La première ligne du passage (ordre réel) porte le choix, les commandes et les heures ; les autres la suivent.
export function groupFollower(visits, visit) {
  const group = loadingGroup(visits, visit);
  return group.length > 1 && group.reduce((first, other) => (other.actual_sequence < first.actual_sequence ? other : first)).id !== visit.id;
}
